import { useState } from 'react'
import Table from '../../../atoms/display/Table'
import TableRow from '../../../atoms/display/TableRow'
import TableCell from '../../../atoms/display/TableCell'
import { FlexColumn, FlexRow } from '../../../atoms/layout/Flex'
import Label from '../../../atoms/display/Label'
import Button from '../../../atoms/inputs/Button'
import IconButton from '../../../atoms/inputs/IconButton'
import { DetailIcon } from '../../../atoms/display/Icons'
import { Company, VisitorRegistrationRecord } from '../../../../types/Company'
import { useVisitorRegistrationFormSubmitDialog } from '../../../../hooks/useDialog'
import useDay from '../../../../hooks/useDay'
import VisitorRegistrationRecordConfirmDialog from './ConfirmDialog'

type Props = {
  clients: Company[]
  submittedRecords: VisitorRegistrationRecord[]
  receivedRecords: VisitorRegistrationRecord[]
}

function SubmittedRecordView(props: {
  client: Company
  records: VisitorRegistrationRecord[]
  onClickDetail: (record: VisitorRegistrationRecord) => void
}) {
  const { client, records, onClickDetail } = props
  const day = useDay()
  const submitDialog = useVisitorRegistrationFormSubmitDialog()
  const record = records.find((entry) => entry.client.id === client.id)

  if (record) {
    return (
      <FlexColumn>
        <FlexRow align="center" justify="center">
          <Label text={day.formatDate(record.updatedAt)} />
          <Label text="提出済み" />
        </FlexRow>
        <FlexRow align="center" justify="center">
          <IconButton label="詳細" onClick={() => onClickDetail(record)}>
            <DetailIcon />
          </IconButton>
          <Button height="small" size="sm" onClick={() => submitDialog.open(client)}>
            再提出
          </Button>
        </FlexRow>
      </FlexColumn>
    )
  }
  return (
    <FlexRow align="center" justify="center">
      <Label text="未提出" />
      <Button height="small" size="sm" onClick={() => submitDialog.open(client)}>
        提出する
      </Button>
    </FlexRow>
  )
}

function ReceivedRecordView(props: {
  client: Company
  records: VisitorRegistrationRecord[]
  onClickDetail: (record: VisitorRegistrationRecord) => void
}) {
  const { client, records, onClickDetail } = props
  const day = useDay()
  const record = records.find((entry) => entry.company.id === client.id)

  if (record) {
    return (
      <FlexRow align="center" justify="center">
        <Label text={day.formatDate(record.createdAt)} />
        <Label text="提出済み" />
        <IconButton label="詳細" onClick={() => onClickDetail(record)}>
          <DetailIcon />
        </IconButton>
      </FlexRow>
    )
  }
  return (
    <FlexRow align="center" justify="center">
      <Label text="未提出" />
    </FlexRow>
  )
}

export default function VisitorRegistrationClientTable(props: Props) {
  const { clients, submittedRecords, receivedRecords } = props
  const [displayRecord, setDisplayRecord] = useState<VisitorRegistrationRecord | null>(null)

  return (
    <>
      <Table
        header={
          <TableRow>
            <TableCell header>取引先名</TableCell>
            <TableCell header size="md">
              自社の提出状況
            </TableCell>
            <TableCell header size="md">
              取引先の提出状況
            </TableCell>
          </TableRow>
        }
      >
        {clients.map((client) => (
          <TableRow key={client.id}>
            <TableCell>{client.name}</TableCell>
            <TableCell size="md">
              <SubmittedRecordView client={client} records={submittedRecords} onClickDetail={setDisplayRecord} />
            </TableCell>
            <TableCell size="md">
              <ReceivedRecordView client={client} records={receivedRecords} onClickDetail={setDisplayRecord} />
            </TableCell>
          </TableRow>
        ))}
      </Table>
      {displayRecord && (
        <VisitorRegistrationRecordConfirmDialog
          open={displayRecord !== null}
          record={displayRecord}
          onClose={() => setDisplayRecord(null)}
        />
      )}
    </>
  )
}
